"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHalfWidth = exports.isFullWidth = exports.default = exports.DEFAULT_CARDS_PER_ROW_FOR_HALF_WIDTH = void 0;

var _preact = require("preact");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _QuickLinksContainer = require("../quick-links/QuickLinksContainer.sync");

var _classnames = _interopRequireDefault(require("classnames"));

var _common = require("@insided/shared/utils/common");

var _index = require("./index.sync");

var DEFAULT_CARDS_PER_ROW_FOR_HALF_WIDTH = 2;
exports.DEFAULT_CARDS_PER_ROW_FOR_HALF_WIDTH = DEFAULT_CARDS_PER_ROW_FOR_HALF_WIDTH;
var isClient = (typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) === 'object';

var FeaturedCardContainer = function FeaturedCardContainer(props) {
  var className = props.className,
      contentType = props.contentType,
      featuredImage = props.featuredImage,
      children = props.children,
      isSidebar = props.isSidebar;
  return (0, _preact.h)("article", {
    className: (0, _classnames.default)(className, 'featured-topic', {
      'featured-topic--featured-image': featuredImage,
      'featured-topic--idea': contentType === 'idea',
      'featured-topic--bug': _common.common.isModuleActive('bugContentType') && _index.CONVERSATION_LIKE_TYPES.includes(contentType),
      'featured-topic--full-width': !isSidebar && isFullWidth(props)
    }),
    style: "--cards-per-row: ".concat(isSidebar ? 1 : getCardsPerRow(props))
  }, children);
};

var isFullWidth = function isFullWidth(props) {
  var isMobile = isClient && (0, _insidedDataStorage.getInsidedData)('device') === 'mobile';

  if (isMobile) {
    return false;
  }

  var index = props.index,
      totalTopics = props.totalTopics,
      topicsFullWidth = props.topicsFullWidth;

  if (index < topicsFullWidth) {
    return true;
  }

  return totalTopics - topicsFullWidth === 1;
};

exports.isFullWidth = isFullWidth;

var isHalfWidth = function isHalfWidth(props) {
  if (isFullWidth(props)) {
    return false;
  }

  var isMobile = isClient && (0, _insidedDataStorage.getInsidedData)('device') === 'mobile';

  if (isMobile) {
    return false;
  }

  var index = props.index,
      totalTopics = props.totalTopics,
      topicsFullWidth = props.topicsFullWidth;

  if (index < topicsFullWidth) {
    return true;
  }

  if (totalTopics - topicsFullWidth === 2) {
    return true;
  }

  return totalTopics - topicsFullWidth === 4;
};

exports.isHalfWidth = isHalfWidth;

var getCardsPerRow = function getCardsPerRow(props) {
  var selectedCardsPerRow = props.selectedCardsPerRow,
      isNested = props.isNested;

  if (selectedCardsPerRow !== undefined) {
    return selectedCardsPerRow;
  }

  if (isHalfWidth(props)) {
    return DEFAULT_CARDS_PER_ROW_FOR_HALF_WIDTH;
  }

  return isNested ? _QuickLinksContainer.DEFAULT_NESTED_CARDS_PER_ROW : _QuickLinksContainer.DEFAULT_CARDS_PER_ROW;
};

var _default = FeaturedCardContainer;
exports.default = _default;